import { Button, Form, Modal } from 'react-bootstrap'
import { AccountIntegration, ListingsOrderItem } from '../../utilities/listings.interfaces'
import { SALESFORCE_URLS_BY_ENVIRONMENT } from '../../../common/common.entities'
import { DateTime } from 'luxon'
import { useCallback, useEffect, useMemo, useState } from 'react'

interface ListingsOrderItemsModalProps {
  orderItems: ListingsOrderItem[]
  modalVisible: boolean
  closeModal: any
  title: string
  environment: string
  account?: string
  accountIntegrations: AccountIntegration[]
}

export default function ListingsOrderItemsModal(props: ListingsOrderItemsModalProps){
  const [filtered, setFiltered] = useState([])
  const [selectedAccount, setSelectedAccount] = useState('all')

  useEffect(() => {
    if(!props.orderItems) return

    let index = 1
    for(const oi of props.orderItems){
      oi.index = index
      index += 1
    }

    if(props.account){
      setFiltered(props.orderItems.filter(oi => oi.Order.Account?.Name === props.account || oi.Order.Account.Order_Integration__c === props.account))
    }
  }, [props.orderItems, props.account])

  const handleAccountSelected = useCallback((e) => {
    if(e.target.value === 'all'){
      setFiltered([])
      setSelectedAccount(e.target.value)
      return
    }
    setSelectedAccount(e.target.value)
    setFiltered(props.orderItems.filter(oi => oi.Order.Account.Name === e.target.value || oi.Order.Account.Order_Integration__c === props.account).sort((a, b) => {return a.Order.Account.Name.localeCompare(b.Order.Account.Name)}))
  }, [props.orderItems])

  const view = useMemo(() => {
    if(!props.orderItems) return <></>
    const list = filtered.length > 0 ? filtered : props.orderItems
    return <Modal show={props.modalVisible} animation={false} onHide={props.closeModal} className='modal-xl'>
    <Modal.Header 
      closeButton
      style={{ 
        position: 'sticky', 
        top: -1, 
        zIndex: 1050, 
        backgroundColor: 'white', 
        borderBottom: '1px solid #ddd'
      }}
    >
      <Modal.Title>
        <span className='beacon-header'>{props.title}</span>
      </Modal.Title>
    </Modal.Header>
      
    <Modal.Body>
      <div style={{fontSize: 'larger'}}>
        <div>
          <span className='beacon-label'>ACCOUNT SELECTION</span>
          <Form.Select onChange={handleAccountSelected}>
            <option selected={!props.account} value='all'>ALL</option>
            {props.accountIntegrations.map(ai => (
              <option selected={props.account === ai.Name || props.account === ai.Order_Integration__c} value={ai.Name}>{ai.Name}</option>
            ))}
          </Form.Select>
        </div>
        <span className='beacon-label'>{filtered.length > 0 ? filtered.length : props.orderItems.length} order item(s). {filtered.length} found in {props.accountIntegrations.filter(ai => selectedAccount === ai.Name || ai.Name === props.account || ai.Order_Integration__c === props.account).map(ai => ai.Name).join(', ')}</span>
        <table className='flexport-table'>
          <thead>
            <tr className='sticky-row'>
              <th>
                <span className='beacon-header'>ORDER</span>
              </th>
              <th>
                <span className='beacon-header'>ACCOUNT</span>
              </th>
              <th>
                <span className='beacon-header'>QTY</span>
              </th>
              <th>
                <span className='beacon-header'>ORDER DATE</span>
              </th>     
              <th>
                <span className='beacon-header'>STATUS</span>
              </th>   
            </tr>
          </thead>
          <tbody>
            {list.map((oi, index) => (
              <tr>
                <td>
                  <a href={`${SALESFORCE_URLS_BY_ENVIRONMENT[props.environment]}/${oi.Order.Id}`}  className='beacon-link' target="_blank" rel="noopener noreferrer">{oi.Order.Name}</a>
                </td>
                <td>
                  <a href={`${SALESFORCE_URLS_BY_ENVIRONMENT[props.environment]}/${oi.Order.Account?.Id}`}  className='beacon-link' target="_blank" rel="noopener noreferrer">{oi.Order.Account.Name}</a>
                </td>
                <td>
                  {oi.Quantity}
                </td>
                <td>
                  {DateTime.fromISO(oi.Order.Order_Time__c).toFormat('MM/dd/yy t')}
                </td>
                <td>
                  {oi.Order.Status__c}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <Button variant='secondary' onClick={props.closeModal}>CLOSE</Button>
    </Modal.Footer>
  </Modal>
  }, [filtered, props])

  return view 
}